import { render } from "./EmailView.vue?vue&type=template&id=74e187bb&scoped=true"
import script from "./EmailView.vue?vue&type=script&lang=js"
export * from "./EmailView.vue?vue&type=script&lang=js"

import "./EmailView.vue?vue&type=style&index=0&id=74e187bb&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/aethonspel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e187bb"]])

export default __exports__